import React, { Component } from 'react';
import isEqual from 'lodash/isEqual';
import { Link } from 'react-router-dom';

import Card from '../../components/Card';
import FormWrapper from '../../containers/Forms/FormWrapper';
import FormStackSettingsBasicInfo from '../../containers/Forms/FormStackSettingsBasicInfo';
import ApiKeyWizard from './ApiKeyWizard';
import ApiKeysTable from './ApiKeysTable';
import { VerifyDeleteDialog } from 'components/Shared/VerifyDeleteDialog';
import {
  route,
  resourceTypes,
  entityNames,
  infoPanelTypes,
  apiKeyRoles,
} from '../../config/constants';
import './style.css';
import InfoPanel from '../Shared/InfoPanel/InfoPanel';

export default class StackSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isWizardOpen: false,
      isDeleteDialogOpen: false,
      apiKeyToDelete: null,
    };
  }

  componentDidMount = () => {
    const { currentAccount, getApiKeys } = this.props;
    if (currentAccount) {
      getApiKeys(currentAccount.uuid);
    }
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    if (!isEqual(this.props.currentAccount, nextProps.currentAccount)) {
      this.props.getApiKeys(nextProps.currentAccount.uuid);
    }

    // When API keys change (e.g., after delete), close delete dialog
    if (!isEqual(nextProps.apiKeys, this.props.apiKeys)) {
      this.setState({
        isDeleteDialogOpen: false,
        apiKeyToDelete: null,
      });
    }
  };

  render() {
    const { t, apiKeys, createdApiKey, isFetching, isLoadingApiKeys } = this.props;
    const { isWizardOpen, isDeleteDialogOpen, apiKeyToDelete } = this.state;
    const isPersonalAccount = this.checkPersonalAccount();

    const apiKeyToDeleteObj = apiKeyToDelete
      ? apiKeys && apiKeys.find(function(key) { return key.uuid === apiKeyToDelete; })
      : null;

    return (
      <div className="inner-page page_stack-settings">
        <div className="inner-page-header">
          <div className="inner-page-title">
            <h1>{t('stackSettings:stackSettings')}</h1>
          </div>
        </div>

        <Card
          title={t('stackSettings:basicInformation')}
          content={
            <div>
              {isPersonalAccount && (
                <div className="page_stack-settings-message">
                  <InfoPanel type={infoPanelTypes.WARNING}>
                    {t('stackSettings:thisInformationIsLinked')}{' '}
                    <Link to={route.PROFILE}>{t('stackSettings:here')}</Link>.
                  </InfoPanel>
                </div>
              )}

              <FormWrapper
                type="edit"
                entityName={entityNames.UPDATE_ACCOUNT}
                entity={['name', 'imageUUID']}
                jsonPatchResource={resourceTypes.ACCOUNT}
                onSubmit={this.onUpdateAccount}
              >
                <FormStackSettingsBasicInfo />
              </FormWrapper>
            </div>
          }
        />

        <Card
          title={t('stackSettings:apiKeys')}
          content={
            <div>
              <button
                type="button"
                className="settings-add-btn apikeys-add-btn"
                onClick={this.handleOpenWizard}
                disabled={isPersonalAccount}
              >
                <span className="material-symbols-outlined">add</span>
                {t('btn:addApiKey')}
              </button>

              <ApiKeysTable
                apiKeys={apiKeys}
                onDelete={this.handleOpenDeleteDialog}
                disabled={isPersonalAccount}
                loading={isLoadingApiKeys}
              />
            </div>
          }
        />

        <ApiKeyWizard
          open={isWizardOpen}
          onClose={this.handleCloseWizard}
          onSubmit={this.handleCreateApiKey}
          isFetching={isFetching}
          createdApiKey={createdApiKey}
        />

        <VerifyDeleteDialog
          open={isDeleteDialogOpen}
          onClose={this.handleCloseDeleteDialog}
          onConfirm={this.handleConfirmDelete}
          itemName={apiKeyToDeleteObj ? apiKeyToDeleteObj.name : ''}
          itemType={t('stackSettings:apiKey')}
          title={t('stackSettings:deleteApiKey')}
          message={t('stackSettings:deleteApiKeyMessage', {
            name: apiKeyToDeleteObj ? apiKeyToDeleteObj.name : '',
          })}
        />
      </div>
    );
  }

  onUpdateAccount = (data, entityName) => {
    this.props.updateAccount(data, entityName);
  };

  handleOpenWizard = () => {
    this.setState({ isWizardOpen: true });
  };

  handleCloseWizard = () => {
    const { currentAccount, createdApiKey } = this.props;
    // If a key was created, refresh the API keys list
    if (createdApiKey && currentAccount) {
      this.props.getApiKeys(currentAccount.uuid);
    }
    this.props.clearCreatedApiKey();
    this.setState({ isWizardOpen: false });
  };

  handleCreateApiKey = (data) => {
    // Include both roles by default
    const apiKeyData = {
      name: data.name,
      roles: [apiKeyRoles.SLATE_IMPORT, apiKeyRoles.SLATE_UPDATE].join(','),
    };
    this.props.createApiKey(apiKeyData, entityNames.CREATE_API_KEY);
  };

  handleOpenDeleteDialog = (uuid) => {
    this.setState({
      isDeleteDialogOpen: true,
      apiKeyToDelete: uuid,
    });
  };

  handleCloseDeleteDialog = () => {
    this.setState({
      isDeleteDialogOpen: false,
      apiKeyToDelete: null,
    });
  };

  handleConfirmDelete = (data) => {
    const { apiKeyToDelete } = this.state;
    if (apiKeyToDelete) {
      // Pass the name for API validation, and uuid separately for the URL
      this.props.removeApiKey({ name: data.name, uuid: apiKeyToDelete }, entityNames.REMOVE_API_KEY);
    }
  };

  checkPersonalAccount = () => {
    const { currentUser, currentAccount } = this.props;
    let result = false;

    if (currentUser && currentAccount) {
      result = currentUser.personalAccountUUID === currentAccount.uuid;
    }
    return result;
  };
}
